import React, { useState, useEffect } from 'react'
import Handlebars from "handlebars"
import "./Section.11.Description.css"


export default function EndSection(params) {

    const {rescue, values} = params
    const [template, setTemplate] = useState()
    
    useEffect(() => {
        if (!template)
            setTemplate(values?.templates?.[0])
    }, [values, template])
    
    const onChangeTemplate = (event) => {
        const index = event.target.selectedIndex
        const name = event.target.value
        const text = event.target.options[index].dataset?.template
        if (text) setTemplate({name: name, text: text})
    }
    
    const applyTemplate = () => {
        const templateTemplate = Handlebars.compile(template.text)
        const text = templateTemplate(rescue.rescue)
        rescue.setField("description", text)
    }
    
    return <li className="accordion" id="accordion-description">
        <input type="checkbox" className="accordion" name="accordion" id="acc-description"/>
        <label className="accordion" htmlFor="acc-description">Opis</label>
        <section className="accordion">          
            {!rescue.isReadOnly && <div id="template-header">
      		    <select id="template-select" value={template?.name} onChange={onChangeTemplate}>
          		    {values?.templates?.map(template => <option key={template.name} value={template.name} data-template={template.text}>{template.name}</option>)}
      		    </select>
      		    <button className="btn btn-light btn-sm" onClick={applyTemplate} title="Iskopiraj predložak"><i className="fa-solid fa-arrow-turn-down"/>&nbsp;&nbsp;Upotrebi predložak</button>
            </div>}
            <textarea id="description" placeholder="Opis akcije..." onChange={rescue.onChange} value={rescue.rescue.description || ''} readOnly={rescue.isReadOnly}/>
        </section>
    </li>
    
}